import { useEffect, useState } from "react";
import { useAppStore } from "@/hooks/useAppStore";
import { DisplayMessage } from "@/types";


export default function GameLauncher () {
  const isReady = useAppStore((state) => state.isReady);
  const messages = useAppStore((state) => state.messages);
  const sendGameEvent = useAppStore((state) => state.sendGameEvent);
  const [lastTimestamp, setLastTimestamp] = useState(0);

  useEffect(() => {
    if (!isReady) return;

    const lastMessage = [...messages]
      .filter((msg) => msg.timestamp > lastTimestamp && msg.type == "message")
      .sort((a, b) => a.timestamp - b.timestamp)
      .pop();

    if (!lastMessage) return;

    setLastTimestamp(lastMessage.timestamp);
    const message: string = (lastMessage as DisplayMessage).message

    if (/crocodile/i.test(message)) return sendGameEvent('crocodile', 'new', null);
  }, [messages]);

  return null;
};
